export const Types = {
    GET_EXCEL_FOR_UPDATE_DATE: "GET_EXCEL_FOR_UPDATE_DATE",
    POST_UPLOAD_FILE_FOR_UPDATE_DATE: "POST_UPLOAD_FILE_FOR_UPDATE_DATE",
    GET_EXCEL_LIST_FOR_UPDATE_DATE: "GET_EXCEL_LIST_FOR_UPDATE_DATE",
    SET_EXCEL_LIST_FOR_UPDATE_DATE: "SET_EXCEL_LIST_FOR_UPDATE_DATE",
};

//download
export const postExportTasksForUpdateDate = (payload) => ({
    type: Types.GET_EXCEL_FOR_UPDATE_DATE,
    payload,
});

//upload
export const postUpdateTaskDatesFromExcel = (payload) => ({
    type: Types.POST_UPLOAD_FILE_FOR_UPDATE_DATE,
    payload,
});

//exceltolist
export const getExcelListForUpdateDate = (payload) => ({
    type: Types.GET_EXCEL_LIST_FOR_UPDATE_DATE,
    payload,
});

export const setExcelListForUpdateDate = (payload) => ({
    type: Types.SET_EXCEL_LIST_FOR_UPDATE_DATE,
    payload,
});
